export const GET_LIST_START = "@games/GET_LIST_START";
export const GET_LIST_SUCCESS = "@games/GET_LIST_SUCCESS";
export const GET_LIST_FAIL = "@games/GET_LIST_FAIL";
export const GET_DETAIL_START = "@games/GET_DETAIL_START";
export const GET_DETAIL_SUCCESS = "@games/GET_DETAIL_SUCCESS";
export const GET_DETAIL_FAIL = "@games/GET_DETAIL_FAIL";
export const GET_GAME_CONFIGURATIONS_START = "@games/GET_GAME_CONFIGURATIONS_START";
export const GET_GAME_CONFIGURATIONS_SUCCESS = "@games/GET_GAME_CONFIGURATIONS_SUCCESS";
export const GET_GAME_CONFIGURATIONS_FAIL = "@games/GET_GAME_CONFIGURATIONS_FAIL";
